import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

type Props = {
  children: ReactNode;
};

export type LoadingContextType = {
  showLoading: boolean;
  setShowLoading: Dispatch<SetStateAction<boolean>>;
};

export const LoadingContext = createContext<LoadingContextType>({
  showLoading: false,
  setShowLoading: () => {},
});

export const LoadingProvider = ({ children }: Props) => {
  const [showLoading, setShowLoading] = useState<boolean>(false);

  return <LoadingContext.Provider value={{ showLoading, setShowLoading }}>{children}</LoadingContext.Provider>;
};

export const useLoading = () => {
  return useContext(LoadingContext);
};
